var map = {
	"./en-US/global.ftl": [
		"c1f2",
		"chunk-450a2cb1"
	],
	"./en-US/profile.ftl": [
		"ca17",
		"chunk-57935fbc"
	],
	"./pt-BR/global.ftl": [
		"c011",
		"chunk-306d3de8"
	],
	"./pt-BR/profile.ftl": [
		"710f",
		"chunk-0cf1eb60"
	],
	"./pt/global.ftl": [
		"40b8",
		"chunk-4981f096"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "06a7";
module.exports = webpackAsyncContext;